import * as React from 'react';
import { Modal } from '@cian/ui-kit';
import { setModalClose } from '../../../slices';
import { useReferrerAppDispatch } from '../../../hooks';
import { useSelector } from 'react-redux';
import { selectPageModal } from '../../../selectors';
import { EModalStatus } from '../../../types/referrer/page';
import { SendPhoneNumberModal } from '../SendPhoneNumberModal';
import { SendVerificationCodeModal } from '../SendVerificationCodeModal';
import { ErrorModalContent } from '../../../components/Modals';

const MODAL_CONTENT_MAPPER = {
  [EModalStatus.GetVerificationCode]: SendPhoneNumberModal,
  [EModalStatus.SendVerificationCode]: SendVerificationCodeModal,
  [EModalStatus.Error]: ErrorModalContent,
};

export const ModalsContainer: React.FC = () => {
  const dispatch = useReferrerAppDispatch();

  const { status, isOpen } = useSelector(selectPageModal);
  const ContentComponent = MODAL_CONTENT_MAPPER[status];

  const handleCloseModal = React.useCallback(() => {
    dispatch(setModalClose());
  }, [dispatch]);

  return (
    <Modal open={isOpen} onOpenChange={handleCloseModal} size="S">
      <ContentComponent />
    </Modal>
  );
};
